import DetailPage from "../detailPage/DetailPage";
import FinancialPage from "../financialPage/FinancialPage";
import MainPage from "../mainPage/MainPage";
import styles from "./tabsPage.module.css";
import { useState } from "react";
import { Link } from "react-scroll/modules";
import { BsCalendarDay } from "react-icons/bs";
import { BsTable, BsCloudUpload } from "react-icons/bs";
import { BiDetail } from "react-icons/bi";
import { FaRegSave } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import MealProvider from "../../../Context/MealsProvider";
import TableProvider from "../../../Context/TablesProvider";
import TableFixedProvider from "../../../Context/TableFixedProvider";
import TableFinacialProvider from "../../../Context/TableFinancial";
import React, { forwardRef, useRef, useImperativeHandle } from "react";

import "./tabs-page.scss";
const TabsPage = () => {
  const [value, setValue] = useState([]);
  const [days, setDays] = useState([{ name: "روز حرکت", id: 0 }]);
  const mainPageRef = useRef();

  function setDasteBandi(newCat) {
    setValue([...newCat]);
  }
  const changeHandlerDaste = (option) => {
    setValue(option);
  };
  const addDayHandler = (dayoo = 1, oneDay = false) => {
    if (oneDay) return null;
    let newArray = [];
    let dayNum = days.length;
    for (let index = 0; index < dayoo; index++) {
      if (days.length < 11) {
        let newDay = {
          id: Math.floor(Math.random() * 1000),
          dayNum: dayNum,
        };
        ++dayNum;
        newArray.push(newDay);
      }

      setDays([...days, ...newArray]);
    }
  };

  return (
    <MealProvider>
      <TableProvider>
        <TableFixedProvider>
          <TableFinacialProvider>
            <div className={`${styles.container} tab-page-container`}>
              <ul className={`nav nav-tabs ${styles.nav}`} id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                    مشخصات تور
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">
                    گزارشات
                  </button>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  <div className={styles.toolTip}>
                    <Link to="specification" smooth={true} duration={0}>
                      <h3 data-tip="مشخصات">
                        <BiDetail className={styles.imgIcon} />
                      </h3>
                      <ReactTooltip />
                    </Link>
                    <Link to="detail" smooth={true} duration={0}>
                      <h4 data-tip="روزها">
                        <BsCalendarDay className={styles.imgIcon} />
                      </h4>
                      <ReactTooltip />
                    </Link>
                    <Link to="financial" smooth={true} duration={0}>
                      <h4 data-tip="جداول">
                        <BsTable className={styles.imgIcon} />
                      </h4>
                      <ReactTooltip />
                    </Link>
                    <div
                      onClick={() => {
                        mainPageRef.current.clickSaveHandler();
                      }}
                    >
                      <h4 data-tip="ثبت">
                        <FaRegSave className={styles.imgIcon} />
                      </h4>
                      <ReactTooltip />
                    </div>
                  </div>

                  <MainPage changeHandlerDaste={changeHandlerDaste} catValue={value} setValue={setDasteBandi} addDayHandler={addDayHandler} days={days} setDays={setDays} ref={mainPageRef} />
                  <DetailPage changeHandlerDaste={changeHandlerDaste} catValue={value} addDayHandler={addDayHandler} days={days} setDays={setDays} />
                </div>

                <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                  <FinancialPage />
                </div>
              </div>
            </div>
          </TableFinacialProvider>
        </TableFixedProvider>
      </TableProvider>
    </MealProvider>
  );
};

export default TabsPage;
